import { render } from "./MatchBet.vue?vue&type=template&id=400adbf0"
import script from "./MatchBet.vue?vue&type=script&lang=js"
export * from "./MatchBet.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__